import { render, staticRenderFns } from "./video-play.vue?vue&type=template&id=d7fafbf4&scoped=true"
import script from "./video-play.vue?vue&type=script&lang=js"
export * from "./video-play.vue?vue&type=script&lang=js"
import style0 from "./video-play.vue?vue&type=style&index=0&id=d7fafbf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fafbf4",
  null
  
)

export default component.exports